// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import LazyImage from "@conklin/MobiusOverrides/LazyImage/LazyImage";
import { mergeWithCss } from "@conklin/XDL/Utilities/mergeWithCss";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Clickable from "@insite/mobius/Clickable";
import Link, { LinkProps } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useState } from "react";

interface OwnProps {
    category: any;
    categoryImage: string;
    extendedStyles?: CategoryItemStyles;
}

type Props = OwnProps;

export interface CategoryItemStyles {
    categoryItem?: InjectableCss;
    categoryTitle?: LinkProps;
    imageWrapper?: InjectableCss;
    image?: InjectableCss;
}

export const categoryItemStyles: CategoryItemStyles = {};

const CategoryItem: FC<Props> = ({ category, categoryImage, extendedStyles }) => {
    const [styles] = useState(() => mergeWithCss(categoryItemStyles, extendedStyles));

    if (!category) {
        return null;
    }

    return (
        <StyledWrapper {...styles.categoryItem}>
            <Clickable
                href={category?.url || category?.path}
                {...styles.imageWrapper}
                aria-label="category image clickable"
            >
                <LazyImage {...styles.image} src={categoryImage} altText={category.imageAltText} />
            </Clickable>
            <Link
                aria-label={category.name}
                href={category?.url || category?.path}
                {...styles.categoryTitle}
                data-test-selector="category-title-link"
            >
                {category.shortDescription ?? category.name}
            </Link>
        </StyledWrapper>
    );
};

export default CategoryItem;
